// eslint-disable-next-line import/prefer-default-export
export const Modes = {
  TRANSIT: 'TRANSIT',
  BUS: 'BUS',
  WALK: 'WALK',
  SUBWAY: 'SUBWAY',
  RAIL: 'RAIL'
}
